module.exports = __webpack_public_path__ + "images/emoji/curly_loop.fca63c21ceac4ba4b03e.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/curly_loop.png
// module id = +yuB
// module chunks = 2